import React from 'react';

import ResourceEmptyState from './ResourceEmptyState.react';
import GetStartedWithAlbert from './GetStartedWithAlbert.react';

interface Props {
  title: string;
  body: string;
}

const EmptyState = ({title, body}: Props) => {
  return (
    <div className='u-display_flex u-max-width_legacy u-mar-lr_auto u-flex-wrap_wrap'>
      <ResourceEmptyState title={title} body={body} />
      <GetStartedWithAlbert />
    </div>
  );
};

export default EmptyState;
